// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ========================================
   RESPONSIVE POPUP COMPONENTS STYLES
   ======================================== */
/* Base responsive container for all popup dialogs */
.responsive-popup-container {
  padding: 0 !important;
  max-height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
  width: 100%;
  height: 100%;
}

/* Base responsive box for popup content */
.responsive-popup-box {
  max-width: 560px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 15px 15px 0px 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
  opacity: 1 !important;
  -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
}

/* Responsive header styles */
.responsive-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: -25px;
  margin-right: -25px;
  padding: 12px 16px;
  background: #fff !important;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
  min-height: 60px;
}
.responsive-popup-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 1.3;
}
.responsive-popup-header .header-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #333;
  background: transparent !important;
  border: none !important;
  box-shadow: none;
}

/* Responsive close button */
.responsive-popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #212427;
  opacity: 1 !important;
  z-index: 10;
  cursor: pointer;
  background: transparent;
  border: none;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
.responsive-popup-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.responsive-popup-close .close-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

/* Responsive content area */
.responsive-popup-content {
  flex: 1;
  overflow-y: auto;
  background: #fff !important;
  padding: 24px;
  -webkit-overflow-scrolling: touch;
}

/* Responsive box wrapper */
.responsive-popup-box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

/* Responsive description box */
.responsive-popup-des-box {
  background: #fff;
  position: relative;
  width: 100%;
}
.responsive-popup-des-box::after {
  content: "";
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 0px !important;
  position: absolute;
  top: 0;
  z-index: -1;
  left: 0;
  right: 0;
}

/* Responsive title box */
.responsive-popup-title-box {
  padding: 0px 0px 60px 0px;
  width: 100%;
}
.responsive-popup-title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
}
.responsive-popup-title-box ul {
  margin: 0px;
  padding: 0px;
}
.responsive-popup-title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}
.responsive-popup-title-box ul li span {
  margin-right: 8px;
}

/* Responsive dialog actions */
.responsive-popup-actions {
  padding: 16px 20px;
  min-height: 60px;
  position: sticky;
  bottom: 0;
  background: #f8f9fa;
  border-top: 1px solid #e0e0e0;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: visible;
  overflow-y: hidden;
}
.responsive-popup-actions button {
  min-height: 48px;
  min-width: 120px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  border: none;
  cursor: pointer;
}
.responsive-popup-actions button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.responsive-popup-actions button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.responsive-popup-actions .cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}
.responsive-popup-actions .cancel-btn:hover:not(:disabled) {
  background: #e8e8e8;
}
.responsive-popup-actions .primary-btn {
  background: #5ea1d8;
  color: white;
}
.responsive-popup-actions .primary-btn:hover:not(:disabled) {
  background: #4a8bc2;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);
}
.responsive-popup-actions .success-btn {
  background: #28a745;
  color: white;
}
.responsive-popup-actions .success-btn:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}
.responsive-popup-actions .danger-btn {
  background: #dc3545;
  color: white;
}
.responsive-popup-actions .danger-btn:hover:not(:disabled) {
  background: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* ========================================
   MOBILE RESPONSIVE BREAKPOINTS
   ======================================== */
/* Tablet and below (768px and below) */
@media (max-width: 768px) {
  .responsive-popup-container {
    max-height: 95vh !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-box {
    max-width: 95vw !important;
    width: 95vw !important;
    margin: 2.5vh auto !important;
    padding: 0px 15px !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    max-height: 90vh !important;
    border-radius: 8px;
  }
  .responsive-popup-header {
    padding: 16px 20px;
    min-height: 60px;
  }
  .responsive-popup-header h2 {
    font-size: 18px;
    line-height: 1.3;
  }
  .responsive-popup-header .header-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .responsive-popup-close {
    min-width: 44px;
    min-height: 44px;
    padding: 8px;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .responsive-popup-close .close-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
  .responsive-popup-content {
    padding: 20px;
    max-height: calc(95vh - 140px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-actions {
    padding: 16px 20px;
    min-height: 60px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
    border-top: 1px solid #e0e0e0;
    display: flex;
    gap: 12px;
    justify-content: center;
    align-items: center;
  }
  .responsive-popup-actions button {
    min-height: 48px;
    min-width: 120px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    padding: 12px 20px;
  }
  .responsive-popup-actions button mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
/* Small mobile devices (480px and below) */
@media (max-width: 480px) {
  .responsive-popup-container {
    max-height: 95vh !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-box {
    max-width: 98vw !important;
    width: 98vw !important;
    margin: 2.5vh auto !important;
    padding: 0px 12px !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    border-radius: 6px;
  }
  .responsive-popup-header {
    padding: 12px 16px;
    min-height: 56px;
  }
  .responsive-popup-header h2 {
    font-size: 16px;
    line-height: 1.3;
  }
  .responsive-popup-header .header-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
  .responsive-popup-close {
    min-width: 44px;
    min-height: 44px;
    padding: 10px;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .responsive-popup-close .close-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .responsive-popup-content {
    padding: 16px;
    max-height: calc(98vh - 120px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-actions {
    padding: 12px 16px;
    min-height: 56px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
    border-top: 1px solid #e0e0e0;
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
  }
  .responsive-popup-actions button {
    min-height: 44px;
    min-width: 100px;
    font-size: 13px;
    padding: 10px 16px;
  }
  .responsive-popup-actions button mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}
/* ========================================
   LANDSCAPE ORIENTATION SUPPORT
   ======================================== */
/* Mobile landscape orientation */
@media (max-width: 768px) and (orientation: landscape) {
  .responsive-popup-container {
    max-height: 100vh !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-box {
    max-height: 95vh !important;
    width: 98vw !important;
    max-width: 98vw !important;
    margin: 1vh auto !important;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-content {
    max-height: calc(95vh - 120px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .responsive-popup-actions {
    padding: 12px 16px;
    min-height: 50px;
    position: sticky;
    bottom: 0;
  }
}
/* ========================================
   ACCESSIBILITY IMPROVEMENTS
   ======================================== */
/* Focus management for better accessibility */
.responsive-popup-container *:focus-visible {
  outline: 2px solid #5ea1d8 !important;
  outline-offset: 2px !important;
}
.responsive-popup-container .restricted-tab-bar button:focus,
.responsive-popup-container .restricted-tab-bar button:focus-visible,
.responsive-popup-container .restricted-tab-bar button:active {
  outline: none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
}
.responsive-popup-container button, .responsive-popup-container .clickable {
  -webkit-tap-highlight-color: rgba(94, 161, 216, 0.2);
  transition: all 0.2s ease;
}
.responsive-popup-container button, .responsive-popup-container .clickable {
  -webkit-user-select: none;
  user-select: none;
}
.responsive-popup-container .responsive-popup-content {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

/* ========================================
   DARK MODE SUPPORT
   ======================================== */
/* Use body.theme-dark directly — more reliable than :host-context
   for Material Dialog content that renders outside the component tree. */
body.theme-dark .responsive-popup-box {
  background: #111827 !important;
  color: #e2e8f0 !important;
}

body.theme-dark .responsive-popup-header {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .responsive-popup-content {
  background: #111827 !important;
  color: #e2e8f0 !important;
}

body.theme-dark .responsive-popup-des-box {
  background: #111827 !important;
  color: #e2e8f0 !important;
}

body.theme-dark .responsive-popup-des-box::after,
body.theme-dark .responsive-popup-des-box::before {
  background: #111827 !important;
}

body.theme-dark .responsive-popup-actions {
  background: #1f2937 !important;
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}

/* ========================================
   HIGH CONTRAST SUPPORT
   ======================================== */
@media (prefers-contrast: high) {
  .responsive-popup-box {
    border: 2px solid #000000;
  }
  .responsive-popup-header {
    border-bottom: 2px solid #000000;
  }
  .responsive-popup-actions {
    border-top: 2px solid #000000;
  }
}
/* ========================================
   REDUCED MOTION SUPPORT
   ======================================== */
@media (prefers-reduced-motion: reduce) {
  .responsive-popup-container * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
/* ========================================
   FORM ELEMENTS RESPONSIVE STYLES
   ======================================== */
.responsive-form-field {
  width: 100%;
  margin-bottom: 16px;
}
.responsive-form-field input, .responsive-form-field textarea, .responsive-form-field select {
  width: 100%;
  min-height: 44px;
  font-size: 16px;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: border-color 0.2s ease;
  -webkit-appearance: none;
  appearance: none;
}
.responsive-form-field input:focus, .responsive-form-field textarea:focus, .responsive-form-field select:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}
.responsive-form-field input::placeholder, .responsive-form-field textarea::placeholder, .responsive-form-field select::placeholder {
  color: #999;
}
.responsive-form-field textarea {
  min-height: 80px;
  resize: vertical;
  font-family: inherit;
}

/* ========================================
   LIST AND SELECTION RESPONSIVE STYLES
   ======================================== */
.responsive-list .list-item {
  min-height: 60px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}
.responsive-list .list-item:hover {
  background-color: #f8f9fa;
}
.responsive-list .list-item.selected {
  background-color: #e3f2fd;
  border-left: 4px solid #5ea1d8;
}
.responsive-list .list-item .item-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.responsive-list .list-item .item-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.responsive-list .list-item .item-avatar .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}
.responsive-list .list-item .item-content {
  flex: 1;
  min-width: 0;
}
.responsive-list .list-item .item-content .item-title {
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  font-size: 16px;
  line-height: 1.4;
}
.responsive-list .list-item .item-content .item-subtitle {
  color: #666;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ========================================
   PAGINATION RESPONSIVE STYLES
   ======================================== */
.responsive-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 0;
  border-top: 1px solid #e0e0e0;
  margin-top: 16px;
}
.responsive-pagination .nav-btn {
  min-width: 44px;
  min-height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid #e0e0e0;
  color: #666;
  transition: all 0.2s ease;
}
.responsive-pagination .nav-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.responsive-pagination .nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.responsive-pagination .nav-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.responsive-pagination .page-numbers {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}
.responsive-pagination .page-numbers .page-btn {
  min-width: 44px;
  min-height: 44px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  background: white;
  color: #666;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.responsive-pagination .page-numbers .page-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.responsive-pagination .page-numbers .page-btn.active {
  background: #5ea1d8;
  color: white;
  border-color: #5ea1d8;
}
.responsive-pagination .page-numbers .page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ========================================
   LOADING AND EMPTY STATES
   ======================================== */
.responsive-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #666;
  font-size: 14px;
}
.responsive-loading mat-spinner {
  margin-right: 8px;
}

.responsive-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
}
.responsive-empty mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #ccc;
}

/* ========================================
   UTILITY CLASSES
   ======================================== */
.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.d-flex {
  display: flex;
}

.d-block {
  display: block;
}

.d-none {
  display: none;
}

.align-items-center {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-end {
  justify-content: flex-end;
}

.w-100 {
  width: 100%;
}

.h-100 {
  height: 100%;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-1 {
  margin-bottom: 8px;
}

.mb-2 {
  margin-bottom: 16px;
}

.mb-3 {
  margin-bottom: 24px;
}

.mt-0 {
  margin-top: 0;
}

.mt-1 {
  margin-top: 8px;
}

.mt-2 {
  margin-top: 16px;
}

.mt-3 {
  margin-top: 24px;
}

.p-0 {
  padding: 0;
}

.p-1 {
  padding: 8px;
}

.p-2 {
  padding: 16px;
}

.p-3 {
  padding: 24px;
}

.font-weight-bold {
  font-weight: bold;
}

.font-weight-normal {
  font-weight: normal;
}

.text-muted {
  color: #666;
}

.text-primary {
  color: #5ea1d8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}

.text-warning {
  color: #ffc107;
}

.passkey-setup-dialog .responsive-popup-box {
  padding: 0;
}
.passkey-setup-dialog .responsive-popup-header {
  margin-left: 0;
  margin-right: 0;
  padding: 16px 24px;
  min-height: 56px;
}
.passkey-setup-dialog .responsive-popup-header h2 {
  padding-right: 40px;
  font-size: 18px;
  font-weight: 600;
  text-align: left;
  color: #1a1a1a;
}
.passkey-setup-dialog .responsive-popup-close {
  top: 6px;
  right: 12px;
}
.passkey-setup-dialog .responsive-popup-box-wrap {
  padding: 0;
}
.passkey-setup-dialog .responsive-popup-content {
  padding: 16px 24px 8px;
}
.passkey-setup-dialog .responsive-popup-actions {
  padding: 16px 24px;
  margin: 0;
}
.passkey-setup-dialog .passkey-setup-message {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #555;
  text-align: left;
}
.passkey-setup-dialog .alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  font-size: 13px;
  padding: 10px 12px;
  margin-top: 14px;
  text-align: left;
}
.passkey-setup-dialog .responsive-popup-actions .btn-primary,
.passkey-setup-dialog .responsive-popup-actions .btn-secondary {
  min-width: 120px;
  min-height: 44px;
}
.passkey-setup-dialog .btn-primary,
.passkey-setup-dialog button.btn-primary,
.passkey-setup-dialog .btn.btn-primary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: #5ea1d8;
  color: #ffffff;
  text-transform: none;
  letter-spacing: 0;
}
.passkey-setup-dialog .btn-primary:hover:not(:disabled),
.passkey-setup-dialog button.btn-primary:hover:not(:disabled),
.passkey-setup-dialog .btn.btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.passkey-setup-dialog .btn-primary:disabled,
.passkey-setup-dialog button.btn-primary:disabled,
.passkey-setup-dialog .btn.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.passkey-setup-dialog .btn-secondary,
.passkey-setup-dialog button.btn-secondary,
.passkey-setup-dialog .btn.btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #5ea1d8;
  background: #fff;
  color: #5ea1d8;
  text-transform: none;
  letter-spacing: 0;
}
.passkey-setup-dialog .btn-secondary:hover:not(:disabled),
.passkey-setup-dialog button.btn-secondary:hover:not(:disabled),
.passkey-setup-dialog .btn.btn-secondary:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.08);
}
.passkey-setup-dialog .btn-secondary:disabled,
.passkey-setup-dialog button.btn-secondary:disabled,
.passkey-setup-dialog .btn.btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

body.theme-dark .passkey-setup-dialog .responsive-popup-header h2 {
  color: #f1f5f9;
}
body.theme-dark .passkey-setup-dialog .passkey-setup-message {
  color: #cbd5e1;
}
body.theme-dark .passkey-setup-dialog .alert-danger {
  color: #fecaca;
  background-color: rgba(127, 29, 29, 0.35);
  border-color: rgba(248, 113, 113, 0.45);
}
body.theme-dark .passkey-setup-dialog .btn-secondary {
  background: transparent;
  color: #93c5fd;
  border-color: rgba(148, 163, 184, 0.45);
}
body.theme-dark .passkey-setup-dialog .btn-secondary:hover:not(:disabled) {
  background: rgba(148, 163, 184, 0.12);
}

@media (max-width: 768px) {
  .passkey-setup-dialog .responsive-popup-box {
    padding: 0 !important;
  }
  .passkey-setup-dialog .responsive-popup-header {
    padding: 16px 20px;
  }
  .passkey-setup-dialog .responsive-popup-content {
    padding: 12px 20px 8px;
  }
  .passkey-setup-dialog .responsive-popup-actions {
    padding: 16px 20px;
  }
}
@media (max-width: 640px) {
  .passkey-setup-dialog .responsive-popup-header {
    padding: 12px 16px;
  }
  .passkey-setup-dialog .responsive-popup-content {
    padding: 12px 16px 8px;
  }
  .passkey-setup-dialog .responsive-popup-actions {
    padding: 12px 16px;
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 10px;
  }
  .passkey-setup-dialog .responsive-popup-actions .btn-primary,
  .passkey-setup-dialog .responsive-popup-actions .btn-secondary {
    width: 100%;
    min-height: 44px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/passkey-setup-dialog/passkey-setup-dialog.component.scss","webpack://./src/app/shared/styles/responsive-popup.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;6CAAA;AAIA,oDAAA;AACA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EAGA,kBAAA;EACA,WAAA;EACA,YAAA;ADDF;;ACIA,0CAAA;AACA;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;EACA,qBAAA;EACA,wCAAA;UAAA,gCAAA;ADFF;;ACKA,6BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;ADFF;ACIE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;ADFJ;ACKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,uBAAA;EACA,gBAAA;ADHJ;;ACOA,4BAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;ADJF;ACME;EACE,oCAAA;ADJJ;ACOE;EACE,eAAA;EACA,WAAA;EACA,YAAA;ADLJ;;ACSA,4BAAA;AACA;EACE,OAAA;EACA,gBAAA;EACA,2BAAA;EACA,aAAA;EACA,iCAAA;ADNF;;ACSA,2BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;ADNF;;ACSA,+BAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;ADNF;ACQE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;ADNJ;;ACUA,yBAAA;AACA;EACE,yBAAA;EACA,WAAA;ADPF;ACSE;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;ADPJ;ACUE;EACE,WAAA;EACA,YAAA;ADRJ;ACWE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;ADTJ;ACYE;EACE,iBAAA;ADVJ;;ACcA,8BAAA;AACA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;ADXF;ACaE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;ADXJ;ACaI;EACE,eAAA;EACA,WAAA;EACA,YAAA;ADXN;ACcI;EACE,YAAA;EACA,mBAAA;ADZN;ACgBE;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;ADdJ;ACgBI;EACE,mBAAA;ADdN;ACkBE;EACE,mBAAA;EACA,YAAA;ADhBJ;ACkBI;EACE,mBAAA;EACA,2BAAA;EACA,8CAAA;ADhBN;ACoBE;EACE,mBAAA;EACA,YAAA;ADlBJ;ACoBI;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;ADlBN;ACsBE;EACE,mBAAA;EACA,YAAA;ADpBJ;ACsBI;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;ADpBN;;ACyBA;;6CAAA;AAIA,uCAAA;AACA;EACE;IACE,2BAAA;IACA,gBAAA;IACA,iCAAA;EDvBF;EC0BA;IACE,0BAAA;IACA,sBAAA;IACA,6BAAA;IACA,4BAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,0BAAA;IACA,2BAAA;IACA,kBAAA;EDxBF;EC2BA;IACE,kBAAA;IACA,gBAAA;EDzBF;EC2BE;IACE,eAAA;IACA,gBAAA;EDzBJ;EC4BE;IACE,eAAA;IACA,WAAA;IACA,YAAA;ED1BJ;EC8BA;IACE,eAAA;IACA,gBAAA;IACA,YAAA;IACA,kCAAA;IACA,uBAAA;IACA,2BAAA;ED5BF;EC8BE;IACE,eAAA;IACA,WAAA;IACA,YAAA;ED5BJ;ECgCA;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;IACA,iCAAA;ED9BF;ECiCA;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;IACA,mBAAA;IACA,6BAAA;IACA,aAAA;IACA,SAAA;IACA,uBAAA;IACA,mBAAA;ED/BF;ECiCE;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,kBAAA;ED/BJ;ECiCI;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;ED/BN;AACF;ACoCA,2CAAA;AACA;EACE;IACE,2BAAA;IACA,gBAAA;IACA,iCAAA;EDlCF;ECqCA;IACE,0BAAA;IACA,sBAAA;IACA,6BAAA;IACA,4BAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,0BAAA;IACA,kBAAA;EDnCF;ECsCA;IACE,kBAAA;IACA,gBAAA;EDpCF;ECsCE;IACE,eAAA;IACA,gBAAA;EDpCJ;ECuCE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EDrCJ;ECyCA;IACE,eAAA;IACA,gBAAA;IACA,aAAA;IACA,kCAAA;IACA,uBAAA;IACA,2BAAA;EDvCF;ECyCE;IACE,eAAA;IACA,WAAA;IACA,YAAA;EDvCJ;EC2CA;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;IACA,iCAAA;EDzCF;EC4CA;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;IACA,mBAAA;IACA,6BAAA;IACA,aAAA;IACA,QAAA;IACA,uBAAA;IACA,mBAAA;ED1CF;EC4CE;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;ED1CJ;EC4CI;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;ED1CN;AACF;AC+CA;;6CAAA;AAIA,iCAAA;AACA;EACE;IACE,4BAAA;IACA,gBAAA;IACA,iCAAA;ED9CF;ECiDA;IACE,2BAAA;IACA,sBAAA;IACA,0BAAA;IACA,2BAAA;IACA,iCAAA;ED/CF;ECkDA;IACE,8BAAA;IACA,gBAAA;IACA,iCAAA;EDhDF;ECmDA;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;EDjDF;AACF;ACoDA;;6CAAA;AAIA,8CAAA;AAEE;EACE,qCAAA;EACA,8BAAA;ADpDJ;ACuDE;;;EAGE,wBAAA;EACA,4BAAA;EACA,2BAAA;ADrDJ;ACyDE;EACE,oDAAA;EACA,yBAAA;ADvDJ;AC2DE;EACE,yBAAA;EAGA,iBAAA;ADzDJ;AC6DE;EACE,uBAAA;EACA,iCAAA;AD3DJ;;AC+DA;;6CAAA;AAIA;yEAAA;AAEA;EACE,8BAAA;EACA,yBAAA;AD7DF;;ACgEA;EACE,8BAAA;EACA,yBAAA;EACA,wDAAA;AD7DF;;ACgEA;EACE,8BAAA;EACA,yBAAA;AD7DF;;ACgEA;EACE,8BAAA;EACA,yBAAA;AD7DF;;ACgEA;;EAEE,8BAAA;AD7DF;;ACgEA;EACE,8BAAA;EACA,qDAAA;AD7DF;;ACgEA;;6CAAA;AAIA;EACE;IACE,yBAAA;ED9DF;ECiEA;IACE,gCAAA;ED/DF;ECkEA;IACE,6BAAA;EDhEF;AACF;ACmEA;;6CAAA;AAIA;EAEI;IACE,qCAAA;IACA,uCAAA;IACA,sCAAA;EDnEJ;AACF;ACuEA;;6CAAA;AAIA;EACE,WAAA;EACA,mBAAA;ADtEF;ACwEE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kCAAA;EACA,wBAAA;EACA,gBAAA;ADtEJ;ACwEI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;ADtEN;ACyEI;EACE,WAAA;ADvEN;AC2EE;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;ADzEJ;;AC6EA;;6CAAA;AAKE;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AD5EJ;AC8EI;EACE,yBAAA;AD5EN;AC+EI;EACE,yBAAA;EACA,8BAAA;AD7EN;ACgFI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AD9EN;ACgFM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AD9ER;ACiFM;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AD/ER;ACmFI;EACE,OAAA;EACA,YAAA;ADjFN;ACmFM;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ADjFR;ACoFM;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADlFR;;ACwFA;;6CAAA;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;ADtFF;ACwFE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;ADtFJ;ACwFI;EACE,mBAAA;EACA,kBAAA;ADtFN;ACyFI;EACE,YAAA;EACA,mBAAA;ADvFN;AC0FI;EACE,eAAA;EACA,WAAA;EACA,YAAA;ADxFN;AC4FE;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,uBAAA;AD1FJ;AC4FI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AD1FN;AC4FM;EACE,mBAAA;EACA,kBAAA;AD1FR;AC6FM;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AD3FR;AC8FM;EACE,YAAA;EACA,mBAAA;AD5FR;;ACkGA;;6CAAA;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;ADhGF;ACkGE;EACE,iBAAA;ADhGJ;;ACoGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;ADjGF;ACmGE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ADjGJ;;ACqGA;;6CAAA;AAIA;EAAe,kBAAA;ADlGf;;ACmGA;EAAa,gBAAA;AD/Fb;;ACgGA;EAAc,iBAAA;AD5Fd;;AC8FA;EAAU,aAAA;AD1FV;;AC2FA;EAAW,cAAA;ADvFX;;ACwFA;EAAU,aAAA;ADpFV;;ACsFA;EAAsB,mBAAA;ADlFtB;;ACmFA;EAA0B,uBAAA;AD/E1B;;ACgFA;EAA2B,8BAAA;AD5E3B;;AC6EA;EAAuB,yBAAA;ADzEvB;;AC2EA;EAAS,WAAA;ADvET;;ACwEA;EAAS,YAAA;ADpET;;ACsEA;EAAQ,gBAAA;ADlER;;ACmEA;EAAQ,kBAAA;AD/DR;;ACgEA;EAAQ,mBAAA;AD5DR;;AC6DA;EAAQ,mBAAA;ADzDR;;AC2DA;EAAQ,aAAA;ADvDR;;ACwDA;EAAQ,eAAA;ADpDR;;ACqDA;EAAQ,gBAAA;ADjDR;;ACkDA;EAAQ,gBAAA;AD9CR;;ACgDA;EAAO,UAAA;AD5CP;;AC6CA;EAAO,YAAA;ADzCP;;AC0CA;EAAO,aAAA;ADtCP;;ACuCA;EAAO,aAAA;ADnCP;;ACqCA;EAAoB,iBAAA;ADjCpB;;ACkCA;EAAsB,mBAAA;AD9BtB;;ACgCA;EAAc,WAAA;AD5Bd;;AC6BA;EAAgB,cAAA;ADzBhB;;AC0BA;EAAgB,cAAA;ADtBhB;;ACuBA;EAAe,cAAA;ADnBf;;ACoBA;EAAgB,cAAA;ADhBhB;;AAt0BE;EACE,UAAA;AAy0BJ;AAt0BE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAw0BJ;AAt0BI;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAw0BN;AAp0BE;EACE,QAAA;EACA,WAAA;AAs0BJ;AAn0BE;EACE,UAAA;AAq0BJ;AAl0BE;EACE,sBAAA;AAo0BJ;AAj0BE;EACE,kBAAA;EACA,SAAA;AAm0BJ;AAh0BE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAk0BJ;AA/zBE;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAi0BJ;AA7zBI;;EAEE,gBAAA;EACA,gBAAA;AA+zBN;AA3zBE;;;EAGE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;AA6zBJ;AA3zBI;;;EACE,mBAAA;AA+zBN;AA5zBI;;;EACE,YAAA;EACA,mBAAA;AAg0BN;AA5zBE;;;EAGE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;AA8zBJ;AA5zBI;;;EACE,oCAAA;AAg0BN;AA7zBI;;;EACE,YAAA;EACA,mBAAA;AAi0BN;;AA3zBE;EACE,cAAA;AA8zBJ;AA3zBE;EACE,cAAA;AA6zBJ;AA1zBE;EACE,cAAA;EACA,yCAAA;EACA,uCAAA;AA4zBJ;AAzzBE;EACE,uBAAA;EACA,cAAA;EACA,uCAAA;AA2zBJ;AAzzBI;EACE,qCAAA;AA2zBN;;AAtzBA;EAEI;IACE,qBAAA;EAwzBJ;EArzBE;IACE,kBAAA;EAuzBJ;EApzBE;IACE,sBAAA;EAszBJ;EAnzBE;IACE,kBAAA;EAqzBJ;AACF;AAjzBA;EAEI;IACE,kBAAA;EAkzBJ;EA/yBE;IACE,sBAAA;EAizBJ;EA9yBE;IACE,kBAAA;IACA,8BAAA;IACA,oBAAA;IACA,SAAA;EAgzBJ;EA9yBI;;IAEE,WAAA;IACA,gBAAA;EAgzBN;AACF","sourcesContent":["@import \"../../shared/styles/responsive-popup.scss\";\n\n.passkey-setup-dialog {\n  .responsive-popup-box {\n    padding: 0;\n  }\n\n  .responsive-popup-header {\n    margin-left: 0;\n    margin-right: 0;\n    padding: 16px 24px;\n    min-height: 56px;\n\n    h2 {\n      padding-right: 40px;\n      font-size: 18px;\n      font-weight: 600;\n      text-align: left;\n      color: #1a1a1a;\n    }\n  }\n\n  .responsive-popup-close {\n    top: 6px;\n    right: 12px;\n  }\n\n  .responsive-popup-box-wrap {\n    padding: 0;\n  }\n\n  .responsive-popup-content {\n    padding: 16px 24px 8px;\n  }\n\n  .responsive-popup-actions {\n    padding: 16px 24px;\n    margin: 0;\n  }\n\n  .passkey-setup-message {\n    margin: 0;\n    font-size: 15px;\n    line-height: 1.5;\n    color: #555;\n    text-align: left;\n  }\n\n  .alert-danger {\n    color: #721c24;\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    border-radius: 8px;\n    font-size: 13px;\n    padding: 10px 12px;\n    margin-top: 14px;\n    text-align: left;\n  }\n\n  .responsive-popup-actions {\n    .btn-primary,\n    .btn-secondary {\n      min-width: 120px;\n      min-height: 44px;\n    }\n  }\n\n  .btn-primary,\n  button.btn-primary,\n  .btn.btn-primary {\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: none;\n    background: #5ea1d8;\n    color: #ffffff;\n    text-transform: none;\n    letter-spacing: 0;\n\n    &:hover:not(:disabled) {\n      background: #4a8fc4;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  .btn-secondary,\n  button.btn-secondary,\n  .btn.btn-secondary {\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1px solid #5ea1d8;\n    background: #fff;\n    color: #5ea1d8;\n    text-transform: none;\n    letter-spacing: 0;\n\n    &:hover:not(:disabled) {\n      background: rgba(94, 161, 216, 0.08);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n}\n\nbody.theme-dark .passkey-setup-dialog {\n  .responsive-popup-header h2 {\n    color: #f1f5f9;\n  }\n\n  .passkey-setup-message {\n    color: #cbd5e1;\n  }\n\n  .alert-danger {\n    color: #fecaca;\n    background-color: rgba(127, 29, 29, 0.35);\n    border-color: rgba(248, 113, 113, 0.45);\n  }\n\n  .btn-secondary {\n    background: transparent;\n    color: #93c5fd;\n    border-color: rgba(148, 163, 184, 0.45);\n\n    &:hover:not(:disabled) {\n      background: rgba(148, 163, 184, 0.12);\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .passkey-setup-dialog {\n    .responsive-popup-box {\n      padding: 0 !important;\n    }\n\n    .responsive-popup-header {\n      padding: 16px 20px;\n    }\n\n    .responsive-popup-content {\n      padding: 12px 20px 8px;\n    }\n\n    .responsive-popup-actions {\n      padding: 16px 20px;\n    }\n  }\n}\n\n@media (max-width: 640px) {\n  .passkey-setup-dialog {\n    .responsive-popup-header {\n      padding: 12px 16px;\n    }\n\n    .responsive-popup-content {\n      padding: 12px 16px 8px;\n    }\n\n    .responsive-popup-actions {\n      padding: 12px 16px;\n      flex-direction: column-reverse;\n      align-items: stretch;\n      gap: 10px;\n\n      .btn-primary,\n      .btn-secondary {\n        width: 100%;\n        min-height: 44px;\n      }\n    }\n  }\n}\n","/* ========================================\n   RESPONSIVE POPUP COMPONENTS STYLES\n   ======================================== */\n\n/* Base responsive container for all popup dialogs */\n.responsive-popup-container {\n  padding: 0 !important;\n  max-height: 90vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch; // Smooth scrolling on iOS\n  \n  // Ensure proper positioning on all devices\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n/* Base responsive box for popup content */\n.responsive-popup-box {\n  max-width: 560px;\n  width: 100% !important;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  // box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  border-radius: 15px 15px 0px 0px;\n  margin: 0px auto;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n  background-size: 100% 90%;\n  background-position: top center;\n  opacity: 1 !important;\n  backdrop-filter: none !important;\n}\n\n/* Responsive header styles */\n.responsive-popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-left: -25px;\n  margin-right: -25px;\n  padding: 12px 16px;\n  background: #fff !important;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  position: relative;\n  min-height: 60px; // Ensure adequate touch target\n\n  h2 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    line-height: 1.3;\n  }\n\n  .header-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: #333;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none;\n  }\n}\n\n/* Responsive close button */\n.responsive-popup-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  color: #212427;\n  opacity: 1 !important;\n  z-index: 10;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n  min-width: 44px; // WCAG touch target minimum\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n\n  .close-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n/* Responsive content area */\n.responsive-popup-content {\n  flex: 1;\n  overflow-y: auto;\n  background: #fff !important;\n  padding: 24px;\n  -webkit-overflow-scrolling: touch; // Smooth scrolling on iOS\n}\n\n/* Responsive box wrapper */\n.responsive-popup-box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n/* Responsive description box */\n.responsive-popup-des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n\n  &::after {\n    content: \"\";\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    border-radius: 0px !important;\n    position: absolute;\n    top: 0;\n    z-index: -1;\n    left: 0;\n    right: 0;\n  }\n}\n\n/* Responsive title box */\n.responsive-popup-title-box {\n  padding: 0px 0px 60px 0px;\n  width: 100%;\n\n  h2 {\n    color: #fff !important;\n    font-size: 18px;\n    font-weight: normal;\n    margin-bottom: 20px;\n    text-align: left;\n  }\n\n  ul {\n    margin: 0px;\n    padding: 0px;\n  }\n\n  ul li {\n    color: #fff;\n    list-style: none;\n    padding: 8px 10px 8px 0px;\n    font-size: 16px;\n    text-align: left;\n  }\n\n  ul li span {\n    margin-right: 8px;\n  }\n}\n\n/* Responsive dialog actions */\n.responsive-popup-actions {\n  padding: 16px 20px;\n  min-height: 60px;\n  position: sticky;\n  bottom: 0;\n  background: #f8f9fa;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow-x: visible;\n  overflow-y: hidden;\n\n  button {\n    min-height: 48px;\n    min-width: 120px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 6px;\n    padding: 12px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    transition: all 0.2s ease;\n    border: none;\n    cursor: pointer;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n  }\n\n  .cancel-btn {\n    background: #f5f5f5;\n    color: #666;\n    border: 1px solid #ddd;\n\n    &:hover:not(:disabled) {\n      background: #e8e8e8;\n    }\n  }\n\n  .primary-btn {\n    background: #5ea1d8;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #4a8bc2;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);\n    }\n  }\n\n  .success-btn {\n    background: #28a745;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #218838;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n    }\n  }\n\n  .danger-btn {\n    background: #dc3545;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #c82333;\n      transform: translateY(-1px);\n      box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);\n    }\n  }\n}\n\n/* ========================================\n   MOBILE RESPONSIVE BREAKPOINTS\n   ======================================== */\n\n/* Tablet and below (768px and below) */\n@media (max-width: 768px) {\n  .responsive-popup-container {\n    max-height: 95vh !important;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-box {\n    max-width: 95vw !important;\n    width: 95vw !important;\n    margin: 2.5vh auto !important;\n    padding: 0px 15px !important;\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n    max-height: 90vh !important;\n    border-radius: 8px;\n  }\n\n  .responsive-popup-header {\n    padding: 16px 20px;\n    min-height: 60px;\n\n    h2 {\n      font-size: 18px;\n      line-height: 1.3;\n    }\n\n    .header-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .responsive-popup-close {\n    min-width: 44px;\n    min-height: 44px;\n    padding: 8px;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n\n    .close-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .responsive-popup-content {\n    padding: 20px;\n    max-height: calc(95vh - 140px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-actions {\n    padding: 16px 20px;\n    min-height: 60px;\n    position: sticky;\n    bottom: 0;\n    background: #f8f9fa;\n    border-top: 1px solid #e0e0e0;\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    align-items: center;\n\n    button {\n      min-height: 48px;\n      min-width: 120px;\n      font-size: 14px;\n      font-weight: 500;\n      border-radius: 6px;\n      padding: 12px 20px;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        margin-right: 8px;\n      }\n    }\n  }\n}\n\n/* Small mobile devices (480px and below) */\n@media (max-width: 480px) {\n  .responsive-popup-container {\n    max-height: 95vh !important;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-box {\n    max-width: 98vw !important;\n    width: 98vw !important;\n    margin: 2.5vh auto !important;\n    padding: 0px 12px !important;\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n    border-radius: 6px;\n  }\n\n  .responsive-popup-header {\n    padding: 12px 16px;\n    min-height: 56px;\n\n    h2 {\n      font-size: 16px;\n      line-height: 1.3;\n    }\n\n    .header-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .responsive-popup-close {\n    min-width: 44px;\n    min-height: 44px;\n    padding: 10px;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n\n    .close-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .responsive-popup-content {\n    padding: 16px;\n    max-height: calc(98vh - 120px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-actions {\n    padding: 12px 16px;\n    min-height: 56px;\n    position: sticky;\n    bottom: 0;\n    background: #f8f9fa;\n    border-top: 1px solid #e0e0e0;\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    align-items: center;\n\n    button {\n      min-height: 44px;\n      min-width: 100px;\n      font-size: 13px;\n      padding: 10px 16px;\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        margin-right: 6px;\n      }\n    }\n  }\n}\n\n/* ========================================\n   LANDSCAPE ORIENTATION SUPPORT\n   ======================================== */\n\n/* Mobile landscape orientation */\n@media (max-width: 768px) and (orientation: landscape) {\n  .responsive-popup-container {\n    max-height: 100vh !important;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-box {\n    max-height: 95vh !important;\n    width: 98vw !important;\n    max-width: 98vw !important;\n    margin: 1vh auto !important;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-content {\n    max-height: calc(95vh - 120px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .responsive-popup-actions {\n    padding: 12px 16px;\n    min-height: 50px;\n    position: sticky;\n    bottom: 0;\n  }\n}\n\n/* ========================================\n   ACCESSIBILITY IMPROVEMENTS\n   ======================================== */\n\n/* Focus management for better accessibility */\n.responsive-popup-container {\n  *:focus-visible {\n    outline: 2px solid #5ea1d8 !important;\n    outline-offset: 2px !important;\n  }\n\n  .restricted-tab-bar button:focus,\n  .restricted-tab-bar button:focus-visible,\n  .restricted-tab-bar button:active {\n    outline: none !important;\n    outline-offset: 0 !important;\n    box-shadow: none !important;\n  }\n\n  // Better touch feedback\n  button, .clickable {\n    -webkit-tap-highlight-color: rgba(94, 161, 216, 0.2);\n    transition: all 0.2s ease;\n  }\n\n  // Prevent text selection on interactive elements\n  button, .clickable {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n\n  // Improve scroll behavior\n  .responsive-popup-content {\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n/* ========================================\n   DARK MODE SUPPORT\n   ======================================== */\n\n/* Use body.theme-dark directly — more reliable than :host-context\n   for Material Dialog content that renders outside the component tree. */\nbody.theme-dark .responsive-popup-box {\n  background: #111827 !important;\n  color: #e2e8f0 !important;\n}\n\nbody.theme-dark .responsive-popup-header {\n  background: #111827 !important;\n  color: #e2e8f0 !important;\n  border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .responsive-popup-content {\n  background: #111827 !important;\n  color: #e2e8f0 !important;\n}\n\nbody.theme-dark .responsive-popup-des-box {\n  background: #111827 !important;\n  color: #e2e8f0 !important;\n}\n\nbody.theme-dark .responsive-popup-des-box::after,\nbody.theme-dark .responsive-popup-des-box::before {\n  background: #111827 !important;\n}\n\nbody.theme-dark .responsive-popup-actions {\n  background: #1f2937 !important;\n  border-top-color: rgba(148, 163, 184, 0.2) !important;\n}\n\n/* ========================================\n   HIGH CONTRAST SUPPORT\n   ======================================== */\n\n@media (prefers-contrast: high) {\n  .responsive-popup-box {\n    border: 2px solid #000000;\n  }\n\n  .responsive-popup-header {\n    border-bottom: 2px solid #000000;\n  }\n\n  .responsive-popup-actions {\n    border-top: 2px solid #000000;\n  }\n}\n\n/* ========================================\n   REDUCED MOTION SUPPORT\n   ======================================== */\n\n@media (prefers-reduced-motion: reduce) {\n  .responsive-popup-container {\n    * {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n}\n\n/* ========================================\n   FORM ELEMENTS RESPONSIVE STYLES\n   ======================================== */\n\n.responsive-form-field {\n  width: 100%;\n  margin-bottom: 16px;\n\n  input, textarea, select {\n    width: 100%;\n    min-height: 44px; // WCAG touch target minimum\n    font-size: 16px; // Prevent zoom on iOS\n    padding: 12px 16px;\n    border: 2px solid #e0e0e0;\n    border-radius: 8px;\n    transition: border-color 0.2s ease;\n    -webkit-appearance: none;\n    appearance: none;\n\n    &:focus {\n      outline: none;\n      border-color: #5ea1d8;\n      box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n  }\n\n  textarea {\n    min-height: 80px;\n    resize: vertical;\n    font-family: inherit;\n  }\n}\n\n/* ========================================\n   LIST AND SELECTION RESPONSIVE STYLES\n   ======================================== */\n\n.responsive-list {\n  .list-item {\n    min-height: 60px; // Larger touch targets\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    transition: background-color 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    &.selected {\n      background-color: #e3f2fd;\n      border-left: 4px solid #5ea1d8;\n    }\n\n    .item-avatar {\n      width: 48px;\n      height: 48px;\n      border-radius: 50%;\n      overflow: hidden;\n      flex-shrink: 0;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n\n      .avatar-placeholder {\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);\n        color: white;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 18px;\n        font-weight: 600;\n      }\n    }\n\n    .item-content {\n      flex: 1;\n      min-width: 0;\n\n      .item-title {\n        font-weight: 600;\n        color: #333;\n        margin-bottom: 4px;\n        font-size: 16px;\n        line-height: 1.4;\n      }\n\n      .item-subtitle {\n        color: #666;\n        font-size: 14px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n}\n\n/* ========================================\n   PAGINATION RESPONSIVE STYLES\n   ======================================== */\n\n.responsive-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 16px 0;\n  border-top: 1px solid #e0e0e0;\n  margin-top: 16px;\n\n  .nav-btn {\n    min-width: 44px; // WCAG touch target minimum\n    min-height: 44px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 1px solid #e0e0e0;\n    color: #666;\n    transition: all 0.2s ease;\n\n    &:hover:not(:disabled) {\n      background: #f5f5f5;\n      border-color: #ccc;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .page-numbers {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n    justify-content: center;\n\n    .page-btn {\n      min-width: 44px; // WCAG touch target minimum\n      min-height: 44px;\n      border-radius: 6px;\n      font-size: 14px;\n      font-weight: 500;\n      border: 1px solid #e0e0e0;\n      background: white;\n      color: #666;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &:hover:not(:disabled) {\n        background: #f5f5f5;\n        border-color: #ccc;\n      }\n\n      &.active {\n        background: #5ea1d8;\n        color: white;\n        border-color: #5ea1d8;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\n/* ========================================\n   LOADING AND EMPTY STATES\n   ======================================== */\n\n.responsive-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 32px;\n  color: #666;\n  font-size: 14px;\n\n  mat-spinner {\n    margin-right: 8px;\n  }\n}\n\n.responsive-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px 20px;\n  color: #999;\n  font-size: 14px;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    color: #ccc;\n  }\n}\n\n/* ========================================\n   UTILITY CLASSES\n   ======================================== */\n\n.text-center { text-align: center; }\n.text-left { text-align: left; }\n.text-right { text-align: right; }\n\n.d-flex { display: flex; }\n.d-block { display: block; }\n.d-none { display: none; }\n\n.align-items-center { align-items: center; }\n.justify-content-center { justify-content: center; }\n.justify-content-between { justify-content: space-between; }\n.justify-content-end { justify-content: flex-end; }\n\n.w-100 { width: 100%; }\n.h-100 { height: 100%; }\n\n.mb-0 { margin-bottom: 0; }\n.mb-1 { margin-bottom: 8px; }\n.mb-2 { margin-bottom: 16px; }\n.mb-3 { margin-bottom: 24px; }\n\n.mt-0 { margin-top: 0; }\n.mt-1 { margin-top: 8px; }\n.mt-2 { margin-top: 16px; }\n.mt-3 { margin-top: 24px; }\n\n.p-0 { padding: 0; }\n.p-1 { padding: 8px; }\n.p-2 { padding: 16px; }\n.p-3 { padding: 24px; }\n\n.font-weight-bold { font-weight: bold; }\n.font-weight-normal { font-weight: normal; }\n\n.text-muted { color: #666; }\n.text-primary { color: #5ea1d8; }\n.text-success { color: #28a745; }\n.text-danger { color: #dc3545; }\n.text-warning { color: #ffc107; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
